export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAQMAAABJtOi3AAAAA1BMVEXm6u7pNkXRAAAAC0lEQVR4AWMY5AAAAKAAAVQqnscAAAAASUVORK5CYII="